


















import { Component} from 'vue-property-decorator';
import IntercomMixin from '@/components/helpers/intercom-mixin';

@Component
export default class AdditionalInfo extends IntercomMixin {
  isAdditionalInfoOpened:boolean = false;
  openHandle(){
    this.isAdditionalInfoOpened=!this.isAdditionalInfoOpened;
  }
}
